import { ChangeEvent, Dispatch, SetStateAction } from 'react';

import { TextareaRowsProps } from '@@types/models/Reports';

export const handleTextareaRows = (
    event: ChangeEvent<HTMLTextAreaElement>,
    rowInfo: TextareaRowsProps,
    setRowInfo: Dispatch<SetStateAction<TextareaRowsProps>>,
) => {
    const { maxRows, minRows } = rowInfo;
    const textareaLineHeight = 20;
    const previousRows = event.target.rows;
    event.target.rows = minRows;
    const currentRows = ~~(event.target.scrollHeight / textareaLineHeight);

    if (currentRows === previousRows) event.target.rows = currentRows;

    if (currentRows >= maxRows) {
        event.target.rows = maxRows;
        event.target.scrollTop = event.target.scrollHeight;
    }

    setRowInfo((prevState) => ({
        ...prevState,
        rows: currentRows < maxRows ? currentRows : maxRows,
    }));
};
